
















import { TicketService } from "@share/common/services/ticket/TicketService";
import { TicketType } from "@share/ticketSystem/enums/TicketTypes";
import { Vue, Component, Prop } from "vue-property-decorator";

import TicketEdit from '@share/ticketSystem/components/TicketEdit.vue';
import TicketView from '@share/ticketSystem/components/TicketView.vue';
import PocketBlock from "@share/common/pocket/Pocket.vue";
import { TicketTableHelper } from "@share/ticketSystem/helpers/TicketTableHelper";

@Component({ components: { TicketEdit, TicketView, PocketBlock }})

export default class TicketViewOrEditPart extends Vue {

    @Prop() ticketId: string;
    @Prop() ticketType: TicketType;
    @Prop() isTicketAdmin: boolean;
    @Prop() ticketViewParams: {
        ticketsType: "" | TicketType;
        ticketService: TicketService | null;
        ticketHelper: TicketTableHelper | null;
    }

    @Prop() state: "view" | "edit" | "";

    reset() {
        this.$emit('reset');
    }

    afterSave() {
        this.reset();
    }

    back() {
        this.reset();
    }
}

